import Main from './Main.vue'
import Banners from './components/Banners'
import NovoBanner from './components/NovoBanner'

export default [{
  path: 'banners',
  name: 'banners',
  component: Main,
  children: [
    {path: '/', component: Banners, name: 'banners.lista'},
    {path: 'registrar', component: NovoBanner, name: 'banners.novo'},
    {path: ':id', component: NovoBanner, name: 'banners.show'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/banners/routes.js